export const ChatCardStyles = 
  {
    'root': {
        backgroundColor: '#3286EA',
        borderRadius: '10px',
        boxShadow: '4px 5px 5px 0px rgba(213,213,214,1)',
        display: 'flex',
        marginTop: '5%'
    },
    'content':{
        width: '100%',
        padding: '3%',
        "&:last-child": {
            paddingBottom: '3%'
        }
    },
    'circulo':{
        width: '1rem',
        height: '1rem',
        borderRadius: '50%',
        background: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center' as 'center',
        margin:'0px auto',
        padding:'1%',
        float: 'right' as 'right'
    },
    'link':{
        textDecoration: 'none'
    }
  }